import { useSubscription } from "@apollo/client";
import { ListenToLoaderProgressSubscription } from "../../API";
import { LISTEN_TO_LOAD_PROGRESS } from "../operations/subscriptions";

export const useListenToProgress = (jobId?: string) => {
  const { data, loading, error } =
    useSubscription<ListenToLoaderProgressSubscription>(
      LISTEN_TO_LOAD_PROGRESS,
      {
        variables: {
          jobId: jobId ?? "",
        },
      }
    );

  return { data, loading, error } as const;
};
